import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { useAddFTPExportBatch, useFTPExportBatchById, useUpdateFTPExportBatch } from "../hook/useFTPImportBatches";
import { showToast } from "../../../utils/toastUtils";
import { Spinner } from "reactstrap";


interface FtpExportModalContentProps {
    handleClose: () => void;

  mode:any
  selectedRow:any
}

const FtpExportModalContent: React.FC<FtpExportModalContentProps> = ({
   handleClose,
  mode,
  selectedRow
}) => {
  console.log('selectedRow',selectedRow)
  const[label,setLabel]=useState<any>('')
  const[attachedFun,setAttachedFun]=useState<any>('')
  const[path,setPath]=useState<any>('')
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
  

 const { data: SingleFtpExportBatch, isLoading } =
    useFTPExportBatchById({
      enable: mode === "edit" && !!selectedRow,
      params: { ftpExportBatchId: selectedRow?.FtpExportBatchId },
    });

 const { mutate: addftpExportBatch } = useAddFTPExportBatch();
  const { mutate: updateftpExportBatch } = useUpdateFTPExportBatch();

  useEffect(() => {
    if (mode === "edit" && SingleFtpExportBatch?.data?.FTPExportBatchData) {
      setPath(SingleFtpExportBatch.data.FTPExportBatchData.FtpPath || "");
      setLabel(SingleFtpExportBatch.data.FTPExportBatchData.Label || "");
      setAttachedFun(SingleFtpExportBatch.data.FTPExportBatchData.AttachedFunction || "");
     if(SingleFtpExportBatch?.data?.FTPExportBatchData?.Isenabled==1){
      setIsEnabled(true)
    }else{
      setIsEnabled(false)
    }
    }
  }, [mode, SingleFtpExportBatch]);

     const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (isSubmitting) return;
    
        // Validations
        if (!path) return showToast.warning("Path is required");
        if (!label) return showToast.warning("Label is required");
        if (!attachedFun) return showToast.warning("Attached Function is required");
        // if (!port) return showToast.warning("Port is required");
    
        const payload: any = {
          label: label,
          attachedFunction: attachedFun,
          ftpPath: path,
          isEnabled:isEnabled?1:0
        };
    
        setIsSubmitting(true);
    
        if (mode === "edit" && selectedRow?.FtpExportBatchId) {
          payload.ftpExportBatchId = selectedRow.FtpExportBatchId;
          updateftpExportBatch(payload, {
            onSuccess: () => {
              handleClose?.();
              setIsSubmitting(false);
            },
            onError: (err: any) => {
              console.error(err);
              setIsSubmitting(false);
            },
          });
        } else {
          addftpExportBatch(payload, {
            onSuccess: () => {
              handleClose?.();
              setIsSubmitting(false);
            },
            onError: (err: any) => {
              console.error(err);
              setIsSubmitting(false);
            },
          });
        }
      };

       if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
        {/* <span className="ms-3">Loading SGPI Brands...</span> */}
      </div>
    );
  }
  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <CustomInput
              asterisk
              required
              placeholder="Enter Label"
              label="Label"
              value={label}
              type="text"
              onChange={(e) => setLabel(e.target.value)}
            />
             <CustomInput
              required
              asterisk
              placeholder="Enter Attached Function"
              label="Attached Function"
              value={attachedFun}
              type="text"
              onChange={(e) => setAttachedFun(e.target.value)}
            />
            <CustomInput
              asterisk
              required
              placeholder="Enter FTP Path"
              label="FTP Path"
              value={path}
              type="text"
              onChange={(e) => setPath(e.target.value)}
            />
             <div className="form-check mt-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="isDefault"
            checked={isEnabled}
            onChange={(e) => setIsEnabled(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isDefault">
            isEnabled
          </label>
        </div>
     
      
      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
                 style={{ backgroundColor: "#43B9B2", color: "white" }}
                 type="submit"
                 disabled={isSubmitting}
               >
                 {mode === "edit"
                   ? isSubmitting
                     ? "Updating..."
                     : "Update"
                   : isSubmitting
                   ? "Submitting..."
                   : "Submit"}
               </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default FtpExportModalContent;
